import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

export function getZapTemplateEditUrl(id: string) {
  return new URL(
    `/zap-templates/edit/${encodeURIComponent(id)}`,
    ZAPIER_APP_BASE_URL
  );
}

export function getCreateTestZapUrl(id: string) {
  return new URL(
    `/webintent/create-zap?template=${encodeURIComponent(id)}`,
    ZAPIER_APP_BASE_URL
  );
}
